import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

import { sofStatus } from "./status";

const fmtUsd = (n: number | null | undefined) =>
  n == null ? "—" : `$${n.toLocaleString("ru-RU", { maximumFractionDigits: 2 })}`;

export function SofList() {
  return (
    <List perPage={25} sort={{ field: "submitted_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <FunctionField
          label="Статус"
          render={(r: { status: string }) => {
            const s = sofStatus(r.status);
            return <Chip size="small" color={s.color} label={s.label} />;
          }}
        />
        <TextField source="user_phone" label="Телефон" />
        <TextField source="user_email" label="Email" />
        <FunctionField label="Документов" render={(r: { files_count: number }) => r.files_count} />
        <FunctionField
          label="Одобрено"
          render={(r: { status: string; approved_amount_usd: number | null }) =>
            r.status === "approved" ? fmtUsd(r.approved_amount_usd) : "—"
          }
        />
        <DateField source="submitted_at" label="Отправлена" showTime />
      </Datagrid>
    </List>
  );
}
